import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
} from "@heroui/react";
import React from "react";

/**
 * Team switcher component for selecting which team to view
 * @param {object} props Component props
 * @param {Array} props.teams Array of team objects with {id, name, isPrimary}
 * @param {string} props.selectedTeamId Currently selected team ID
 * @param {function(string): void} props.onTeamChange Callback when team changes
 * @returns {React.ReactElement} Team switcher dropdown
 */
export default function TeamSwitcher({
  teams = [],
  selectedTeamId,
  onTeamChange,
}) {
  const selectedTeam = teams.find((t) => t.id === selectedTeamId);

  if (!selectedTeam) {
    return null;
  }

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button size="sm" variant="flat">
          {selectedTeam.name}
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Team selection"
        selectionMode="single"
        selectedKeys={selectedTeamId ? [selectedTeamId] : []}
        onSelectionChange={(keys) => {
          const selectedId = Array.from(keys)[0];
          if (selectedId) {
            onTeamChange(selectedId);
          }
        }}
      >
        {teams.map((team) => (
          <DropdownItem key={team.id}>
            {team.name}
            {team.isPrimary && " ✓"}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
